export default function (value) {
  return value
  	.toLowerCase()
  	.replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''))
}